function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M.596 20.074C.596 9.307 9.303.561 20.03.561c10.748 0 19.436 8.746 19.436 19.513 0 10.787-8.688 19.513-19.436 19.513C9.303 39.587.596 30.861.596 20.074z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.646 24.641c-5.267-1.496-8.3-6.977-6.803-12.225a10.099 10.099 0 0 1 3.071-4.8l6.433 7.521z",
  className: "icon-secondary",
  fill: "#adb9ca",
  fillRule: "evenodd"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.916 7.752c4.082 3.615 4.451 9.873.836 13.955a9.88 9.88 0 0 1-10.106 2.934l2.701-9.504z",
  fill: "#fff",
  fillRule: "evenodd"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.933 7.596c3.771-3.206 9.33-3.129 13.022.175l-6.608 7.366z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060"
}, React.createElement("path", {
  d: "M12.607 24.622l2.72-9.524 6.59-7.346",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M8.914 7.616l6.414 7.482",
  strokeMiterlimit: 8
}), React.createElement("path", {
  d: "M7.845 21.57c-3.557-4.159-3.07-10.397 1.07-13.954 4.158-3.537 10.397-3.071 13.954 1.088 3.537 4.14 3.07 10.379-1.089 13.935-4.14 3.557-10.378 3.071-13.935-1.069",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.128 20.774l.098.155a5.42 5.42 0 0 0 3.848 1.594 5.432 5.432 0 0 0 3.867-1.594l.098-.155.816.175a6.424 6.424 0 0 1 3.926 5.927v5.403l-2.818 1.03c-1.905.448-3.887.68-5.89.68a25.65 25.65 0 0 1-5.869-.68l-2.837-1.03v-5.403a6.44 6.44 0 0 1 3.945-5.927z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.128 20.774l.098.155a5.42 5.42 0 0 0 3.848 1.594 5.432 5.432 0 0 0 3.867-1.594l.098-.155.816.175a6.424 6.424 0 0 1 3.926 5.927v5.403l-2.818 1.03c-1.905.448-3.887.68-5.89.68a25.65 25.65 0 0 1-5.869-.68l-2.837-1.03v-5.403a6.44 6.44 0 0 1 3.945-5.927z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.632 17.43c0-3.031 2.449-5.519 5.442-5.519 3.012 0 5.442 2.488 5.442 5.52 0 3.051-2.43 5.52-5.442 5.52-2.993 0-5.442-2.469-5.442-5.52z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});
var _ref0 = /*#__PURE__*/React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeMiterlimit: 8
}, React.createElement("path", {
  d: "M.596 20.074C.596 9.307 9.303.561 20.03.561c10.748 0 19.436 8.746 19.436 19.513 0 10.787-8.688 19.513-19.436 19.513C9.303 39.587.596 30.861.596 20.074",
  strokeWidth: 0.9995603099999999
}), React.createElement("path", {
  d: "M18.632 17.43c0-3.031 2.449-5.519 5.442-5.519 3.012 0 5.442 2.488 5.442 5.52 0 3.051-2.43 5.52-5.442 5.52-2.993 0-5.442-2.469-5.442-5.52"
}));
var SvgOrgTabDemographics = function SvgOrgTabDemographics(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrgTabDemographics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Org-Tab-Demographics.768c44fd.svg";
export { ForwardRef as ReactComponent };